import axios from 'axios'
import { authHeader } from './auth'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

export function upperCase (string) {
  return string.charAt(0).toUpperCase() + string.substr(1)
}

export async function getCodePostalVille (search, pays) {
  return new Promise(resolve => {
    window.setTimeout(function () {
      let url = '/codepostalVille?nbMax=40&codePostal=' + search
      if (pays != null) {
        url = url + '&pays=' + pays
      }
      HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
        return resolve({
          result: response.data
        })
      })
    }, Math.random() * 1000 + 250)
  })
}

export async function downloadExportFile (filename, filenameToReturn) {
  return new Promise(resolve => {
    window.setTimeout(function () {
      if (filenameToReturn == null) {
        filenameToReturn = filename
      }
      const urlApi = processEnvConfig.VUE_APP_UBIFLOW_API_URL + '/download_export?file=' + filename
      const instance = axios.create()

      const results = instance({
        url: urlApi,
        method: 'GET',
        responseType: 'blob',
        headers: authHeader()
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filenameToReturn)
        document.body.appendChild(link)
        link.click()
      }).catch(error => {
        return resolve({ type: 'error', message: error })
      })
    }, Math.random() * 1000 + 250)
  })
}

export function deviseSimple (devise) {
  switch (devise) {
    case 'EUR':
      return '€'
      break
    case 'USD':
      return '$'
      break
    default:
      return '€'
      break
  }
}
